import { combineReducers, configureStore } from "@reduxjs/toolkit";
import siteReducer from "./reducers/SiteSlice";
import authReducer from "./reducers/AuthSlice";
import dataReducer from "./reducers/DataSlice";
import userInfoSlice from "./reducers/UserSlice";
import regionSlice from "./reducers/RegionSlice";
import receiverReducer from "./reducers/ReceiverSlice";

const rootReducer = combineReducers({
  site: siteReducer,
  auth: authReducer,
  data: dataReducer,
  userInfo: userInfoSlice,
  region: regionSlice,
  receiver: receiverReducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

// 🔧 ВАЖНО: типы берём из setupStore
export type AppStore = ReturnType<typeof setupStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
